export default "__VITE_ASSET__BqETuNSC__"